module.exports = __webpack_public_path__ + "img/genre.8a2eaa8e.png";